/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sandboxes_Recentbuildsdescription2Inputs */

const id_sandboxes_recentbuildsdescription2 = /** @type {(inputs: Sandboxes_Recentbuildsdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Catatan biner terbaru.`)
};

const ms_sandboxes_recentbuildsdescription2 = /** @type {(inputs: Sandboxes_Recentbuildsdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rekod binari terbaharu.`)
};

const da_sandboxes_recentbuildsdescription2 = /** @type {(inputs: Sandboxes_Recentbuildsdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nyeste binære poster.`)
};

const de_sandboxes_recentbuildsdescription2 = /** @type {(inputs: Sandboxes_Recentbuildsdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neueste Binärdatensätze.`)
};

const en_us2_sandboxes_recentbuildsdescription2 = /** @type {(inputs: Sandboxes_Recentbuildsdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Newest binary records.`)
};

const es_es2_sandboxes_recentbuildsdescription2 = /** @type {(inputs: Sandboxes_Recentbuildsdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registros binarios más nuevos.`)
};

const es_mx2_sandboxes_recentbuildsdescription2 = /** @type {(inputs: Sandboxes_Recentbuildsdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registros de binarios más nuevos.`)
};

const fil_sandboxes_recentbuildsdescription2 = /** @type {(inputs: Sandboxes_Recentbuildsdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mga pinakabagong talaan ng binary.`)
};

const fr_sandboxes_recentbuildsdescription2 = /** @type {(inputs: Sandboxes_Recentbuildsdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enregistrements binaires les plus récents.`)
};

const it_sandboxes_recentbuildsdescription2 = /** @type {(inputs: Sandboxes_Recentbuildsdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registri binari più recenti.`)
};

const hu_sandboxes_recentbuildsdescription2 = /** @type {(inputs: Sandboxes_Recentbuildsdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Legújabb bináris rekordok.`)
};

const nl_sandboxes_recentbuildsdescription2 = /** @type {(inputs: Sandboxes_Recentbuildsdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nieuwste binaire records.`)
};

const no_sandboxes_recentbuildsdescription2 = /** @type {(inputs: Sandboxes_Recentbuildsdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nyeste binære poster.`)
};

const pl_sandboxes_recentbuildsdescription2 = /** @type {(inputs: Sandboxes_Recentbuildsdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Najnowsze rekordy binarne.`)
};

const pt_br2_sandboxes_recentbuildsdescription2 = /** @type {(inputs: Sandboxes_Recentbuildsdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registros binários mais recentes.`)
};

const pt_sandboxes_recentbuildsdescription2 = /** @type {(inputs: Sandboxes_Recentbuildsdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registos binários mais recentes.`)
};

const ro_sandboxes_recentbuildsdescription2 = /** @type {(inputs: Sandboxes_Recentbuildsdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cele mai noi înregistrări binare.`)
};

const fi_sandboxes_recentbuildsdescription2 = /** @type {(inputs: Sandboxes_Recentbuildsdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uusimmat binaaritietueet.`)
};

const sv_sandboxes_recentbuildsdescription2 = /** @type {(inputs: Sandboxes_Recentbuildsdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nyaste binära poster.`)
};

const vi_sandboxes_recentbuildsdescription2 = /** @type {(inputs: Sandboxes_Recentbuildsdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hồ sơ nhị phân mới nhất.`)
};

const tr_sandboxes_recentbuildsdescription2 = /** @type {(inputs: Sandboxes_Recentbuildsdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En yeni ikili kayıtlar.`)
};

const cs_sandboxes_recentbuildsdescription2 = /** @type {(inputs: Sandboxes_Recentbuildsdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nejnovější binární záznamy.`)
};

const bg_sandboxes_recentbuildsdescription2 = /** @type {(inputs: Sandboxes_Recentbuildsdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Най-нови бинарни записи.`)
};

const ru_sandboxes_recentbuildsdescription2 = /** @type {(inputs: Sandboxes_Recentbuildsdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Новейшие бинарные записи.`)
};

const uk_sandboxes_recentbuildsdescription2 = /** @type {(inputs: Sandboxes_Recentbuildsdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Найновіші бінарні записи.`)
};

const ar_sandboxes_recentbuildsdescription2 = /** @type {(inputs: Sandboxes_Recentbuildsdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`أحدث السجلات الثنائية.`)
};

const hi_sandboxes_recentbuildsdescription2 = /** @type {(inputs: Sandboxes_Recentbuildsdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`नवीनतम बाइनरी रिकॉर्ड।`)
};

const th_sandboxes_recentbuildsdescription2 = /** @type {(inputs: Sandboxes_Recentbuildsdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`บันทึกไบนารีใหม่ล่าสุด`)
};

const ja_sandboxes_recentbuildsdescription2 = /** @type {(inputs: Sandboxes_Recentbuildsdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最新のバイナリレコード。`)
};

const zh_cn2_sandboxes_recentbuildsdescription2 = /** @type {(inputs: Sandboxes_Recentbuildsdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最新的二进制记录。`)
};

const zh_hant1_sandboxes_recentbuildsdescription2 = /** @type {(inputs: Sandboxes_Recentbuildsdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最新的二進位制記錄。`)
};

const ko_sandboxes_recentbuildsdescription2 = /** @type {(inputs: Sandboxes_Recentbuildsdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`최신 바이너리 레코드입니다.`)
};

/**
* | output |
* | --- |
* | "Newest binary records." |
*
* @param {Sandboxes_Recentbuildsdescription2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const sandboxes_recentbuildsdescription2 = /** @type {((inputs?: Sandboxes_Recentbuildsdescription2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sandboxes_Recentbuildsdescription2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_sandboxes_recentbuildsdescription2(inputs)
	if (locale === "ms") return ms_sandboxes_recentbuildsdescription2(inputs)
	if (locale === "da") return da_sandboxes_recentbuildsdescription2(inputs)
	if (locale === "de") return de_sandboxes_recentbuildsdescription2(inputs)
	if (locale === "en-US") return en_us2_sandboxes_recentbuildsdescription2(inputs)
	if (locale === "es-ES") return es_es2_sandboxes_recentbuildsdescription2(inputs)
	if (locale === "es-MX") return es_mx2_sandboxes_recentbuildsdescription2(inputs)
	if (locale === "fil") return fil_sandboxes_recentbuildsdescription2(inputs)
	if (locale === "fr") return fr_sandboxes_recentbuildsdescription2(inputs)
	if (locale === "it") return it_sandboxes_recentbuildsdescription2(inputs)
	if (locale === "hu") return hu_sandboxes_recentbuildsdescription2(inputs)
	if (locale === "nl") return nl_sandboxes_recentbuildsdescription2(inputs)
	if (locale === "no") return no_sandboxes_recentbuildsdescription2(inputs)
	if (locale === "pl") return pl_sandboxes_recentbuildsdescription2(inputs)
	if (locale === "pt-BR") return pt_br2_sandboxes_recentbuildsdescription2(inputs)
	if (locale === "pt") return pt_sandboxes_recentbuildsdescription2(inputs)
	if (locale === "ro") return ro_sandboxes_recentbuildsdescription2(inputs)
	if (locale === "fi") return fi_sandboxes_recentbuildsdescription2(inputs)
	if (locale === "sv") return sv_sandboxes_recentbuildsdescription2(inputs)
	if (locale === "vi") return vi_sandboxes_recentbuildsdescription2(inputs)
	if (locale === "tr") return tr_sandboxes_recentbuildsdescription2(inputs)
	if (locale === "cs") return cs_sandboxes_recentbuildsdescription2(inputs)
	if (locale === "bg") return bg_sandboxes_recentbuildsdescription2(inputs)
	if (locale === "ru") return ru_sandboxes_recentbuildsdescription2(inputs)
	if (locale === "uk") return uk_sandboxes_recentbuildsdescription2(inputs)
	if (locale === "ar") return ar_sandboxes_recentbuildsdescription2(inputs)
	if (locale === "hi") return hi_sandboxes_recentbuildsdescription2(inputs)
	if (locale === "th") return th_sandboxes_recentbuildsdescription2(inputs)
	if (locale === "ja") return ja_sandboxes_recentbuildsdescription2(inputs)
	if (locale === "zh-CN") return zh_cn2_sandboxes_recentbuildsdescription2(inputs)
	if (locale === "zh-Hant") return zh_hant1_sandboxes_recentbuildsdescription2(inputs)
	return ko_sandboxes_recentbuildsdescription2(inputs)
});
export { sandboxes_recentbuildsdescription2 as "sandboxes.recentBuildsDescription" }